import React, { useRef, useState } from 'react';
import { find, is, prop, propEq, sortBy, isNil } from 'ramda';
import { useIntl } from 'gatsby-plugin-intl';
import { WIDTH_TYPES, BLOCK_ELEMENTS } from '../../utils/constants';
import { findByType } from '../../utils';
import { TITLE_FOR_CUSTOM_COLORS, ELEMENTS_TYPES } from './timeline.constants';
import {
  Container,
  Header,
  Title,
  Navigation,
  Button,
  PreviousArrowIcon,
  NextArrowIcon,
  Card,
  CardContent,
  CardContentWrapper,
  Slider,
  CardHeaderContainer,
  CardWrapper,
  TimeBarContainer,
  TimeBarSVG,
  DateHeader,
  TimeDot,
  TimeBar,
} from './timeline.styles'
import { getSliderSettings, SLIDER_VARIANTS } from '../slider';
import { CustomTooltip } from '../customTooltip';
import {ExpandableCard} from '../expandableCard'
import ExpandableTimelineCard from './expandableTimelineCard.component';

const renderTitle = ({ value }) => {
  const intl = useIntl();
  return <Title>{intl.formatMessage({ id: value })}</Title>;
};

const renderYear = ({value}) => {
  const intl = useIntl()
  if (!value) return <DateHeader></DateHeader>
  return <DateHeader>{intl.formatMessage({ id: value})}</DateHeader>
} 

export const Timeline = ({elements}) => {
  const getElement = (name) => find(propEq('name', name))(elements) || {};
  const title = getElement(BLOCK_ELEMENTS.TITLE);
  const cards = getElement(BLOCK_ELEMENTS.CARD);
  const { value: type = WIDTH_TYPES.SHORT } = getElement(BLOCK_ELEMENTS.WIDTH);
  const slider = useRef(null);

  const handleNextClick = () => {
    if (!isNil(slider)) {
      slider.current.slickNext();
    }
  };

  const handlePreviousClick = () => {
    if (!isNil(slider)) {
      slider.current.slickPrev();
    }
  };

  const renderCard = ({ elements = [] }, key) => {
    const year = find(propEq('name', 'year'))(elements) || {};
    const cardDate = find(propEq('name', 'year_date'))(elements) || {};
    const markdown = find(propEq('name', 'markdown'))(elements) || {};
    const connection = find(propEq('name', 'connection'))(elements) || {};
    const citation = find(propEq('name', 'citation'))(elements) || {};
    return (
      <div key={key}>
        <TimeBarContainer>
          {renderYear(year)}
          <TimeBarSVG>
            <TimeDot />
            <TimeBar />
          </TimeBarSVG>
        </TimeBarContainer>
        <ExpandableTimelineCard 
          cardDate={cardDate}
          markdown={markdown}
          connection={connection}
          citation={citation}
          />
      </div>
    )
  };

  const renderCards = ({ value = [] }) => sortBy(prop('order'))(value).map(renderCard);

  return (
    <Container type={type}>
      <Header>
        {renderTitle(title)}
        <Navigation>
          <Button onClick={handlePreviousClick}>
            <PreviousArrowIcon />
          </Button>
          <Button onClick={handleNextClick}>
            <NextArrowIcon />
          </Button>
        </Navigation>
      </Header>
      <CardWrapper>{renderCards(cards, type)}</CardWrapper>
      <Slider {...getSliderSettings()} ref={slider} variant={SLIDER_VARIANTS.EQUAL_HEIGHT} itemWidth={300}>
        {renderCards(cards, type)}
      </Slider>
    </Container>
  );
};